import React from 'react';

const FeedbackCriteriaToggleButton = ({
  criterion,
  onClick,
  selected,
  disabled,
  id,
  name,
}) => {
  return (
    <span
      className={`FeedbackCriteriaToggleButton d-fi ai-c jc-c ${
        disabled ? 'disabled' : ''
      }`}
    >
      <input
        onChange={onClick}
        className="FeedbackCriteriaToggleCheckbox"
        id={id}
        type="checkbox"
        checked={selected}
        disabled={disabled}
        name={name}
        value={criterion.id}
      />
      <label htmlFor={id}>{criterion.name}</label>
    </span>
  );
};

export default FeedbackCriteriaToggleButton;
